<template>
    <button
        v-for="filterData in filterDataValues" :key="filterData.label"
        class="filter-item__box q-btn q-btn-outline-dark q-me-1 q-mb-1 q-p-1"
        :class="{'filter-item__box--active': filtersStore.filterIsChecked(field, filterData.label)}"
        :data-field="field" :value="filterData.label"
        :aria-pressed="filtersStore.filterIsChecked(field, filterData.label).toString()"
        @click="updateFilter(field, filterData.label)"
    >
      <small class="filter-item__box-text">{{ filterData.label }}</small>
    </button>

</template>

<script setup lang="ts">
import {defineProps, defineEmits} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
const filtersStore = useFiltersStore();
const emit = defineEmits(['closeDropdown']);

defineProps(['filterDataValues', 'field'])
function updateFilter(field: string, label:string) {
  filtersStore.updateFilter(field, label);
  emit('closeDropdown');
}

</script>

<style scoped>
.serp__filter-item--box {
  display: grid !important;
  grid-template-columns: repeat(3, 3fr);
  width: -moz-max-content !important;
  width: max-content !important;
  min-width: 100%;
}

.filter-item__box-text {
  font-size: 0.75em !important;
}
.filter-item__box:hover{
  background-color: #d33242!important;
  border-color: #d33242!important;
}

.filter-item__box--active {
  background-color: #d33242 !important;
  border-color: #d33242 !important;
  color: #fff;
}

.filter-item__box--active .filter-item__box-text {
  color: #fff;
}


</style>